import ApiRoutes from "api/apiRoutes";
import { exeRequest } from "http/requestConfig";

export default class SocialStatusService {

    static getAll(options, sCallBack, eCallBack) {
        ApiRoutes.socialStatusResource.resourceOptions = Object.assign({}, ApiRoutes.socialStatusResource.resourceOptions, options);
        exeRequest(ApiRoutes.socialStatusResource, {}, sCallBack, eCallBack)
    }
}